<template>
  <div class="inner-container">
    <app-date-inputs :date-range="dateRange" @onDateChange="updateDateRange" />
    <div class="button-container">
      <vs-button
        color="#19535F"
        class="filter-button"
        type="filled"
        size="small"
        icon="autorenew"
        @click="applyFilter()"
        >Load Data</vs-button
      >
    </div>
  </div>
</template>
<script>
import AppDateInputs from "@/components/ui/AppDateInputs";

export default {
  components: {
    "app-date-inputs": AppDateInputs
  },
  props: {
    dateRange: {
      type: Object,
      required: false,
      default() {
        return { ini: new Date().toISOString(), end: new Date().toISOString() };
      }
    }
  },
  methods: {
    openConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: `Warning`,
        text:
          "More than 5 years of data have been selected, this query might take several minutes. Do you want to continue?",
        accept: this.acceptFilters
      });
    },
    acceptFilters() {
      this.$emit("filterClick", this.dateRange);
    },
    applyFilter() {
      const days = this.getDaysBetween(this.dateRange.ini, this.dateRange.end);
      if (days > 1825) {
        this.openConfirm();
      } else {
        this.acceptFilters();
      }
    },
    getDaysBetween(ini, end) {
      const oneDay = 1000 * 60 * 60 * 24; //Get 1 day in milliseconds
      const iniMs = new Date(ini).getTime();
      const endMs = new Date(end).getTime();
      const diff = endMs - iniMs;
      return Math.round(diff / oneDay);
    },
    updateDateRange(newDateRange) {
      this.dateRange = newDateRange;
    }
  }
};
</script>
<style scoped>
.inner-container {
  display: flex;
  flex-grow: 1;
  justify-content: center;
  padding: 0.5rem;
  align-items: center;
}
.button-container {
  margin-left: 2rem;
}
.filter-button {
  margin-top: 5px;
}
</style>
